export const bifrostUrl = 'https://bifrost.loreheart.com'

